interface WindowWithJQueryGlobally extends Window {
  jQuery: any;
  $: any;
}

var w = window as WindowWithJQueryGlobally;
w.jQuery = w.$ = require('../node_modules/jquery/dist/jquery');

import '../node_modules/ie-array-find-polyfill/index';
import '../node_modules/lodash/index';
import '../node_modules/angular/angular';
import '../node_modules/bootstrap-sass/assets/javascripts/bootstrap';
import '../node_modules/angular-resource/angular-resource';
import '../node_modules/angular-cookies/angular-cookies';
import '../node_modules/angular-route/angular-route';
import '../node_modules/svg4everybody/svg4everybody.min';
import '../node_modules/angular-dateParser/dist/angular-dateparser';
import '../node_modules/angular-datepicker/dist/index';
import '../node_modules/angular-datepicker/dist/index.css';
import '../node_modules/ng-contextmenu/dist/ng-contextmenu.min';
import '../node_modules/ng-debounce/dist/ng-debounce';
import '../node_modules/angular-bootstrap/ui-bootstrap-tpls';
import '../node_modules/bootstrap-switch/dist/js/bootstrap-switch';
import '../node_modules/bootstrap-switch/dist/css/bootstrap3/bootstrap-switch.css';
import '../node_modules/angular-bootstrap-switch/dist/angular-bootstrap-switch';
import '../node_modules/tinymce/tinymce';
import '../node_modules/angular-ui-tinymce/dist/tinymce.min';
import '../node_modules/ng-onload/release/ng-onload.min';
import '../node_modules/angular-ui-bootstrap/src/position/position';
